import BaseUtil from "../../../util/BaseUtil";
const type = `@@ActionType/UPDATE@${__filename}`;

const initState = {
    data: null, // 编辑中的模板数据
    selectedData: null, // 选中的数据
    saving: false, // 保存中

    draggedData: null, // 拖动的数据
    editFields: null, // 正在编辑的表单数据字段，由redux进行管理
}

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);
export {
    update,
    reset,
}
export default viewModel;
